import type { GetAuthenticatedUserResponse } from '@ctw/shared/api/auth-service/user';
import type { PractitionerModel } from '@ctw/shared/api/fhir/models/practitioner';
import type { CTWRequestContext } from '@ctw/shared/context/ctw-context';
import type { ZusAuthTokenState } from '@ctw/shared/utils/auth';
import { isEmpty } from 'lodash-es';

export type AuthenticatedZusUser = {
  id: GetAuthenticatedUserResponse['data']['id'];
} & GetAuthenticatedUserResponse['data']['attributes'];

export interface AuthenticatedUserState {
  fullName: string | null;
  authTokenState: CTWRequestContext['authTokenState'];
  zusUser: AuthenticatedZusUser | null;
  practitioner: PractitionerModel | null;
}

interface DetermineFullNameForAuthenticatedUserArgs {
  zusUser: AuthenticatedZusUser | null;
  practitioner: PractitionerModel | null;
}

export const determineFullNameForAuthenticatedUser = ({
  zusUser,
  practitioner,
}: DetermineFullNameForAuthenticatedUserArgs): string | null => {
  if (zusUser && !isEmpty(zusUser.name)) {
    return zusUser.name;
  }

  if (practitioner && !isEmpty(practitioner.fullName)) {
    return practitioner.fullName;
  }

  return null;
};

interface BuildAuthenticatedUserStateArgs {
  authTokenState: ZusAuthTokenState;
  authenticatedUser: AuthenticatedZusUser | null;
  practitioner: PractitionerModel | null;
}

export const buildAuthenticatedUserState = ({
  authTokenState,
  authenticatedUser,
  practitioner,
}: BuildAuthenticatedUserStateArgs): AuthenticatedUserState => ({
  authTokenState,
  fullName: determineFullNameForAuthenticatedUser({
    zusUser: authenticatedUser,
    practitioner,
  }),
  zusUser: authenticatedUser,
  practitioner,
});
